import React from 'react'

export interface InternalView {
  showInternals: boolean
  setShowInternals: (on: boolean) => void
}

export const InternalViewContext = React.createContext<InternalView>({
  showInternals: false,
  setShowInternals: () => {},
})
